import { render, staticRenderFns } from "./ReviewScoreButton.vue?vue&type=template&id=674aefc5&scoped=true&"
import script from "./ReviewScoreButton.vue?vue&type=script&lang=js&"
export * from "./ReviewScoreButton.vue?vue&type=script&lang=js&"
import style0 from "./ReviewScoreButton.vue?vue&type=style&index=0&id=674aefc5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674aefc5",
  null
  
)

export default component.exports